export class ActionBarConfiguration {
  id: string;
  displayname: string;
  description: string;
  position: string; //left, right
  theme: string; // material class (flat, raised) OR icon for mat-icon-button
  type: string; // material class (default, primary, accent, warn)
  linkedobject: string;
  sitetype: string;
  urlid: string;
  icon: string; // material icon string (see https://material.io/icons/)
  usagekeyword: string[]; // used for object list
  order: number; // ascending from left to right
  actionbarresources: string[];
  hasbrother: boolean; // wizard and batch / batchlist (or approval and approvalbatch) with the same name

  private constructor(displayname: string) {
    this.id = displayname;
    this.displayname = displayname;
  }

  static get DefaultFilter(): ActionBarConfiguration {
    return new ActionBarConfiguration('defaultFilter');
  }

  static get DefaultEdit(): ActionBarConfiguration {
    return new ActionBarConfiguration('defaultEdit');
  }

  static get DefaultDelete(): ActionBarConfiguration {
    return new ActionBarConfiguration('defaultDelete');
  }

  static get DefaultCreate(): ActionBarConfiguration {
    return new ActionBarConfiguration('defaultCreate');
  }

  public static readonly defaultRecentDisplayName: string = '_-_default__RECENT_-_';

  static get DefaultRecent(): ActionBarConfiguration {
    return new ActionBarConfiguration(ActionBarConfiguration.defaultRecentDisplayName);
  }
}
